import { QuickEventStatistic } from '../../models/quick-event-statistic';
import { createReducer, on } from '@ngrx/store';
import { cleanUpQuickEventStatistic, getQuickEventStatisticSuccess } from './quick-event-statistic.actions';

export const QuickEventStatisticFeatureKey = 'quickEventStatistic';

export type QuickEventStatisticState = {
  quickEvent: QuickEventStatistic | null,
};

const initialState: QuickEventStatisticState = {
  quickEvent: null,
}

export const quickEventStatisticReducer = createReducer(
  initialState,
  on(getQuickEventStatisticSuccess, (state, { quickEventStatistic }) => ({
    ...state,
    quickEvent: quickEventStatistic,
  })),
  on(cleanUpQuickEventStatistic, (state) => ({
    ...state,
    quickEvent: null,
  }))
);
